import { IEditModifierRestaurantPropertiesContext } from './editModifierRestaurantPropertiesContext';

export enum EditModifierRestaurantPropertiesActionTypes {
	REFETCH_REST_PROPS_DATA = 'REFETCH_REST_PROPS_DATA',
	SET_ALL_DATA = 'SET_ALL_DATA',
	SET_ID_RESTAURANT = 'SET_ID_RESTAURANT',
	SET_DATA_FROM_RESTAURANT = 'SET_DATA_FROM_RESTAURANT',
	CHANGE_PRICE = 'CHANGE_PRICE',
	CHANGE_SUPPLEMENT_PRICE = 'CHANGE_SUPPLEMENT_PRICE',
	CHANGE_QUANTITY_MAX_LIMIT = 'CHANGE_QUANTITY_MAX_LIMIT',
	TOGGLE_IN_STOP = 'TOGGLE_IN_STOP',
	TOGGLE_IS_RESTRICTED = 'TOGGLE_IS_RESTRICTED',
	TOGGLE_IS_PRESELECTED = 'TOGGLE_IS_PRESELECTED',
	TOGGLE_FORCE_DISABLE = 'TOGGLE_FORCE_DISABLE',
	CHANGE_PORTION_SELECTION_MODE = 'CHANGE_PORTION_SELECTION_MODE',
	CHANGE_ACTIVATION_SCHEDULE = 'CHANGE_ACTIVATION_SCHEDULE',
	CHANGE_DEACTIVATION_SCHEDULE = 'CHANGE_DEACTIVATION_SCHEDULE',
	SET_MODIFIER_GROUP = 'SET_MODIFIER_GROUP',
	SET_MODIFIER_GROUP_WITH_ADDITIONAL_DATA = 'SET_MODIFIER_GROUP_WITH_ADDITIONAL_DATA',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	SHOW_ERROR_MODAL_WITH_INFO = 'SHOW_ERROR_MODAL_WITH_INFO',
}

interface IRefetchRestPropsData {
	type: EditModifierRestaurantPropertiesActionTypes.REFETCH_REST_PROPS_DATA;
	payload: {
		needRefetchRestPropsData: IEditModifierRestaurantPropertiesContext['needRefetchRestPropsData'];
	};
}

interface ISetAllData {
	type: EditModifierRestaurantPropertiesActionTypes.SET_ALL_DATA;
	payload: {
		modifierId: IEditModifierRestaurantPropertiesContext['modifierId'];
		modifierName: IEditModifierRestaurantPropertiesContext['modifierName'];
		customerName: IEditModifierRestaurantPropertiesContext['customerName'];
		hasSchedulePriority: IEditModifierRestaurantPropertiesContext['hasSchedulePriority'];
		fetchedRestaurants: IEditModifierRestaurantPropertiesContext['fetchedRestaurants'];
	};
}

interface ISetIDRestaurant {
	type: EditModifierRestaurantPropertiesActionTypes.SET_ID_RESTAURANT;
	payload: {
		IDSelectedRestaurant: IEditModifierRestaurantPropertiesContext['IDSelectedRestaurant'];
		price: IEditModifierRestaurantPropertiesContext['price'];
		supplementPrice: IEditModifierRestaurantPropertiesContext['supplementPrice'];
		isCreatedFromPos: IEditModifierRestaurantPropertiesContext['isCreatedFromPos'];
		quantityMaxLimit: IEditModifierRestaurantPropertiesContext['quantityMaxLimit'];
		inStop: IEditModifierRestaurantPropertiesContext['inStop'];
		isRestricted: IEditModifierRestaurantPropertiesContext['isRestricted'];
		isPreselected: IEditModifierRestaurantPropertiesContext['isPreselected'];
		forceDisable: IEditModifierRestaurantPropertiesContext['forceDisable'];
		activationSchedule: IEditModifierRestaurantPropertiesContext['activationSchedule'];
		deactivationSchedule: IEditModifierRestaurantPropertiesContext['deactivationSchedule'];
		parentModifierGroups: IEditModifierRestaurantPropertiesContext['parentModifierGroups'];
		IDsSelectedModifierGroups: IEditModifierRestaurantPropertiesContext['IDsSelectedModifierGroups'];
		modifierGroupsWithAdditionalData: IEditModifierRestaurantPropertiesContext['modifierGroupsWithAdditionalData'];
		hasPortions: IEditModifierRestaurantPropertiesContext['hasPortions'];
		portionSelectionMode: IEditModifierRestaurantPropertiesContext['portionSelectionMode'];
		hasPortionBasedNestedModGroups: IEditModifierRestaurantPropertiesContext['hasPortionBasedNestedModGroups'];
	};
}

interface ISetDataFromRestaurant {
	type: EditModifierRestaurantPropertiesActionTypes.SET_DATA_FROM_RESTAURANT;
	payload: {
		price: IEditModifierRestaurantPropertiesContext['price'];
		supplementPrice: IEditModifierRestaurantPropertiesContext['supplementPrice'];
		isCreatedFromPos: IEditModifierRestaurantPropertiesContext['isCreatedFromPos'];
		quantityMaxLimit: IEditModifierRestaurantPropertiesContext['quantityMaxLimit'];
		inStop: IEditModifierRestaurantPropertiesContext['inStop'];
		isRestricted: IEditModifierRestaurantPropertiesContext['isRestricted'];
		isPreselected: IEditModifierRestaurantPropertiesContext['isPreselected'];
		forceDisable: IEditModifierRestaurantPropertiesContext['forceDisable'];
		activationSchedule: IEditModifierRestaurantPropertiesContext['activationSchedule'];
		deactivationSchedule: IEditModifierRestaurantPropertiesContext['deactivationSchedule'];
		parentModifierGroups: IEditModifierRestaurantPropertiesContext['parentModifierGroups'];
		IDsSelectedModifierGroups: IEditModifierRestaurantPropertiesContext['IDsSelectedModifierGroups'];
		modifierGroupsWithAdditionalData: IEditModifierRestaurantPropertiesContext['modifierGroupsWithAdditionalData'];
		hasPortions: IEditModifierRestaurantPropertiesContext['hasPortions'];
		portionSelectionMode: IEditModifierRestaurantPropertiesContext['portionSelectionMode'];
		hasPortionBasedNestedModGroups: IEditModifierRestaurantPropertiesContext['hasPortionBasedNestedModGroups'];
	};
}

interface IChangePrice {
	type: EditModifierRestaurantPropertiesActionTypes.CHANGE_PRICE;
	payload: {
		price: IEditModifierRestaurantPropertiesContext['price'];
	};
}

interface IChangeSupplementPrice {
	type: EditModifierRestaurantPropertiesActionTypes.CHANGE_SUPPLEMENT_PRICE;
	payload: {
		supplementPrice: IEditModifierRestaurantPropertiesContext['supplementPrice'];
	};
}

interface IChangeQuantityMaxLimit {
	type: EditModifierRestaurantPropertiesActionTypes.CHANGE_QUANTITY_MAX_LIMIT;
	payload: {
		quantityMaxLimit: IEditModifierRestaurantPropertiesContext['quantityMaxLimit'];
	};
}

interface IToggleInStop {
	type: EditModifierRestaurantPropertiesActionTypes.TOGGLE_IN_STOP;
}

interface IToggleIsRestricted {
	type: EditModifierRestaurantPropertiesActionTypes.TOGGLE_IS_RESTRICTED;
}

interface IToggleIsPreselected {
	type: EditModifierRestaurantPropertiesActionTypes.TOGGLE_IS_PRESELECTED;
}

interface IToggleForceDisable {
	type: EditModifierRestaurantPropertiesActionTypes.TOGGLE_FORCE_DISABLE;
}

interface IChangePortionSelectionMode {
	type: EditModifierRestaurantPropertiesActionTypes.CHANGE_PORTION_SELECTION_MODE;
	payload: {
		portionSelectionMode: IEditModifierRestaurantPropertiesContext['portionSelectionMode'];
	};
}

interface IChangeActivationSchedule {
	type: EditModifierRestaurantPropertiesActionTypes.CHANGE_ACTIVATION_SCHEDULE;
	payload: {
		activationSchedule: IEditModifierRestaurantPropertiesContext['activationSchedule'];
	};
}

interface IChangeDeactivationSchedule {
	type: EditModifierRestaurantPropertiesActionTypes.CHANGE_DEACTIVATION_SCHEDULE;
	payload: {
		deactivationSchedule: IEditModifierRestaurantPropertiesContext['deactivationSchedule'];
	};
}

interface ISetModifierGroups {
	type: EditModifierRestaurantPropertiesActionTypes.SET_MODIFIER_GROUP;
	payload: {
		IDsSelectedModifierGroups: IEditModifierRestaurantPropertiesContext['IDsSelectedModifierGroups'];
	};
}

interface ISetModifierGroupsWithAdditionalData {
	type: EditModifierRestaurantPropertiesActionTypes.SET_MODIFIER_GROUP_WITH_ADDITIONAL_DATA;
	payload: {
		modifierGroupsWithAdditionalData: IEditModifierRestaurantPropertiesContext['modifierGroupsWithAdditionalData'];
	};
}

interface ISetDataForSubmit {
	type: EditModifierRestaurantPropertiesActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: IEditModifierRestaurantPropertiesContext['dataForSubmit'];
	};
}

interface IChangeTypeOfModalWindow {
	type: EditModifierRestaurantPropertiesActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IEditModifierRestaurantPropertiesContext['typeOfModalWindow'];
	};
}

interface IShowErrorModalWithInfo {
	type: EditModifierRestaurantPropertiesActionTypes.SHOW_ERROR_MODAL_WITH_INFO;
	payload: {
		errorResponseData: IEditModifierRestaurantPropertiesContext['errorResponseData'];
	};
}

export type TEditModifierRestaurantPropertiesAction =
	| IRefetchRestPropsData
	| ISetAllData
	| ISetIDRestaurant
	| ISetDataFromRestaurant
	| IChangePrice
	| IChangeSupplementPrice
	| IChangeQuantityMaxLimit
	| IToggleInStop
	| IToggleIsRestricted
	| IToggleIsPreselected
	| IToggleForceDisable
	| IChangePortionSelectionMode
	| IChangeActivationSchedule
	| IChangeDeactivationSchedule
	| ISetModifierGroups
	| ISetModifierGroupsWithAdditionalData
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow
	| IShowErrorModalWithInfo;
